import React from 'react'
import { connect } from 'react-redux'
import { withProps, withHandlers, compose } from 'recompose'
import { reduxForm } from 'redux-form'
import { APPOINTMENT_FORM_NAME } from 'constant'
import { showStoreLocatorModal } from 'actions/storeLocator'
import StoreLocationSelector from './StoreLocationSelector'
import { STORE_LOCATION_SELECTED } from './constants'
import validate from './validate'

const withStoreLocatorHandlers = withHandlers({
  handleEditClick: ({ showStoreLocatorModal }) => () => showStoreLocatorModal()
})

const withExtraProps = withProps(({ isDone, handleEditClick, children }) => {
  const contentProps = {
    showChangeStoreButton: true,
    handleEditClick
  }

  if (isDone) {
    contentProps.question = STORE_LOCATION_SELECTED
  }

  return {
    children: React.cloneElement(children, contentProps)
  }
})

export default compose(
  connect(null, { showStoreLocatorModal }),
  withStoreLocatorHandlers,
  withExtraProps,
  reduxForm({
    validate,
    form: APPOINTMENT_FORM_NAME,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true
  })
)(StoreLocationSelector)
